"use strict";
/**
 * Auto-generated Locale Data File for zh-CN.
 * This is generated in the @box/cldr-data project.
 * @IMPORTANT: DO NOT MODIFY THIS FILE DIRECTLY
 */
exports.__esModule = true;
var languages = {
    id: 6,
    bcp47Tag: 'zh-CN',
    name: 'Chinese (Simplified)',
    localizedName: '简体中文',
    localizedNameList: [
        {
            id: 67,
            name: '澳大利亚英语'
        },
        {
            id: 30,
            name: '波兰语'
        },
        {
            id: 68,
            name: '丹麦语'
        },
        {
            id: 18,
            name: '德语'
        },
        {
            id: 8,
            name: '俄语'
        },
        {
            id: 21,
            name: '法语'
        },
        {
            id: 63,
            name: '繁体中文'
        },
        {
            id: 61,
            name: '芬兰语'
        },
        {
            id: 55,
            name: '韩语'
        },
        {
            id: 24,
            name: '荷兰语'
        },
        {
            id: 65,
            name: '加拿大法语'
        },
        {
            id: 66,
            name: '加拿大英语'
        },
        {
            id: 6,
            name: '简体中文'
        },
        {
            id: 72,
            name: '拉丁美洲西班牙语'
        },
        {
            id: 70,
            name: '孟加拉语'
        },
        {
            id: 14,
            name: '葡萄牙语'
        },
        {
            id: 19,
            name: '日语'
        },
        {
            id: 57,
            name: '瑞典语'
        },
        {
            id: 69,
            name: '书面挪威语'
        },
        {
            id: 49,
            name: '土耳其语'
        },
        {
            id: 10,
            name: '西班牙语'
        },
        {
            id: 16,
            name: '意大利语'
        },
        {
            id: 71,
            name: '印地语'
        },
        {
            id: 59,
            name: '英国英语'
        },
        {
            id: 4,
            name: '英语'
        },
    ]
};
var numbers = {
    long: [
        {
            digits: 1,
            msg: '{count, number}'
        },
        {
            digits: 2,
            msg: '{count, number}'
        },
        {
            digits: 3,
            msg: '{count, number}'
        },
        {
            digits: 4,
            msg: '{count, number}'
        },
        {
            digits: 1,
            msg: '{count, number}万'
        },
        {
            digits: 2,
            msg: '{count, number}万'
        },
        {
            digits: 3,
            msg: '{count, number}万'
        },
        {
            digits: 4,
            msg: '{count, number}万'
        },
        {
            digits: 1,
            msg: '{count, number}亿'
        },
        {
            digits: 2,
            msg: '{count, number}亿'
        },
        {
            digits: 3,
            msg: '{count, number}亿'
        },
        {
            digits: 4,
            msg: '{count, number}亿'
        },
        {
            digits: 1,
            msg: '{count, number}兆'
        },
        {
            digits: 2,
            msg: '{count, number}兆'
        },
    ],
    short: [
        {
            digits: 1,
            msg: '{count, number}'
        },
        {
            digits: 2,
            msg: '{count, number}'
        },
        {
            digits: 3,
            msg: '{count, number}'
        },
        {
            digits: 4,
            msg: '{count, number}'
        },
        {
            digits: 1,
            msg: '{count, number}万'
        },
        {
            digits: 2,
            msg: '{count, number}万'
        },
        {
            digits: 3,
            msg: '{count, number}万'
        },
        {
            digits: 4,
            msg: '{count, number}万'
        },
        {
            digits: 1,
            msg: '{count, number}亿'
        },
        {
            digits: 2,
            msg: '{count, number}亿'
        },
        {
            digits: 3,
            msg: '{count, number}亿'
        },
        {
            digits: 4,
            msg: '{count, number}亿'
        },
        {
            digits: 1,
            msg: '{count, number}兆'
        },
        {
            digits: 2,
            msg: '{count, number}兆'
        },
    ]
};
var timezones = [
    {
        name: 'Pacific/Kiritimati',
        displayName: 'GMT+14:00 基里地马地岛 +14',
        nameLocalized: '基里地马地岛',
        abbreviationStandard: '+14',
        id: 500,
        enabled: true
    },
    {
        name: 'Pacific/Apia',
        displayName: 'GMT+13:00 阿皮亚 +13/+14',
        nameLocalized: '阿皮亚',
        abbreviationStandard: '+13/+14',
        id: 485
    },
    {
        name: 'Pacific/Tongatapu',
        displayName: 'GMT+13:00 东加塔布 +13/+14',
        nameLocalized: '东加塔布',
        abbreviationStandard: '+13/+14',
        id: 520,
        enabled: true
    },
    {
        name: 'Pacific/Fakaofo',
        displayName: 'GMT+13:00 法考福 +13',
        nameLocalized: '法考福',
        abbreviationStandard: '+13',
        id: 491
    },
    {
        name: 'Pacific/Chatham',
        displayName: 'GMT+12:45 查塔姆 +1245/+1345',
        nameLocalized: '查塔姆',
        abbreviationStandard: '+1245/+1345',
        abbreviationDaylight: '+1245/+1345',
        id: 487
    },
    {
        name: 'Asia/Anadyr',
        displayName: 'GMT+12:00 阿纳德尔 +12',
        nameLocalized: '阿纳德尔',
        abbreviationStandard: '+12',
        id: 216
    },
    {
        name: 'Pacific/Auckland',
        displayName: 'GMT+12:00 奥克兰 NZST',
        nameLocalized: '奥克兰',
        abbreviationStandard: 'NZST',
        abbreviationDaylight: 'NZDT',
        id: 486,
        enabled: true
    },
    {
        name: 'Pacific/Fiji',
        displayName: 'GMT+12:00 斐济 +12/+13',
        nameLocalized: '斐济',
        abbreviationStandard: '+12/+13',
        abbreviationDaylight: '+12/+13',
        id: 492,
        enabled: true
    },
    {
        name: 'Pacific/Funafuti',
        displayName: 'GMT+12:00 富纳富提 +12',
        nameLocalized: '富纳富提',
        abbreviationStandard: '+12',
        id: 493
    },
    {
        name: 'Asia/Kamchatka',
        displayName: 'GMT+12:00 堪察加 +12',
        nameLocalized: '堪察加',
        abbreviationStandard: '+12',
        id: 249
    },
    {
        name: 'Pacific/Kwajalein',
        displayName: 'GMT+12:00 夸贾林 +12',
        nameLocalized: '夸贾林',
        abbreviationStandard: '+12',
        id: 502
    },
    {
        name: 'Pacific/Majuro',
        displayName: 'GMT+12:00 马朱罗 +12',
        nameLocalized: '马朱罗',
        abbreviationStandard: '+12',
        id: 503
    },
    {
        name: 'Antarctica/McMurdo',
        displayName: 'GMT+12:00 麦克默多 NZST',
        nameLocalized: '麦克默多',
        abbreviationStandard: 'NZST',
        abbreviationDaylight: 'NZDT',
        id: 206
    },
    {
        name: 'Pacific/Nauru',
        displayName: 'GMT+12:00 瑙鲁 +12',
        nameLocalized: '瑙鲁',
        abbreviationStandard: '+12',
        id: 506
    },
    {
        name: 'Pacific/Tarawa',
        displayName: 'GMT+12:00 塔拉瓦 +12',
        nameLocalized: '塔拉瓦',
        abbreviationStandard: '+12',
        id: 519
    },
    {
        name: 'Pacific/Wallis',
        displayName: 'GMT+12:00 瓦利斯 +12',
        nameLocalized: '瓦利斯',
        abbreviationStandard: '+12',
        id: 523
    },
    {
        name: 'Pacific/Wake',
        displayName: 'GMT+12:00 威克 +12',
        nameLocalized: '威克',
        abbreviationStandard: '+12',
        id: 522
    },
    {
        name: 'Pacific/Efate',
        displayName: 'GMT+11:00 埃法特 +11/+12',
        nameLocalized: '埃法特',
        abbreviationStandard: '+11/+12',
        id: 489
    },
    {
        name: 'Pacific/Guadalcanal',
        displayName: 'GMT+11:00 瓜达尔卡纳尔 +11',
        nameLocalized: '瓜达尔卡纳尔',
        abbreviationStandard: '+11',
        id: 496
    },
    {
        name: 'Antarctica/Casey',
        displayName: 'GMT+11:00 卡塞 +11',
        nameLocalized: '卡塞',
        abbreviationStandard: '+11',
        id: 202
    },
    {
        name: 'Pacific/Kosrae',
        displayName: 'GMT+11:00 库赛埃 +11',
        nameLocalized: '库赛埃',
        abbreviationStandard: '+11',
        id: 501
    },
    {
        name: 'Asia/Magadan',
        displayName: 'GMT+11:00 马加丹 +11',
        nameLocalized: '马加丹',
        abbreviationStandard: '+11',
        id: 259,
        enabled: true
    },
    {
        name: 'Pacific/Noumea',
        displayName: 'GMT+11:00 努美阿 +11/+12',
        nameLocalized: '努美阿',
        abbreviationStandard: '+11/+12',
        id: 509
    },
    {
        name: 'Pacific/Norfolk',
        displayName: 'GMT+11:00 诺福克 +11/+12',
        nameLocalized: '诺福克',
        abbreviationStandard: '+11/+12',
        abbreviationDaylight: '+11/+12',
        id: 508
    },
    {
        name: 'Asia/Sakhalin',
        displayName: 'GMT+11:00 萨哈林 +11',
        nameLocalized: '萨哈林',
        abbreviationStandard: '+11',
        id: 275
    },
    {
        name: 'Australia/Lord_Howe',
        displayName: 'GMT+10:30 豪勋爵 +1030/+11',
        nameLocalized: '豪勋爵',
        abbreviationStandard: '+1030/+11',
        abbreviationDaylight: '+1030/+11',
        id: 320
    },
    {
        name: 'Australia/Brisbane',
        displayName: 'GMT+10:00 布里斯班 AEST',
        nameLocalized: '布里斯班',
        abbreviationStandard: 'AEST',
        id: 311,
        enabled: true
    },
    {
        name: 'Antarctica/DumontDUrville',
        displayName: 'GMT+10:00 迪蒙迪尔维尔 +10',
        nameLocalized: '迪蒙迪尔维尔',
        abbreviationStandard: '+10',
        id: 204
    },
    {
        name: 'Asia/Vladivostok',
        displayName: 'GMT+10:00 符拉迪沃斯托克 +10',
        nameLocalized: '符拉迪沃斯托克',
        abbreviationStandard: '+10',
        id: 293,
        enabled: true
    },
    {
        name: 'Pacific/Guam',
        displayName: 'GMT+10:00 关岛 ChST',
        nameLocalized: '关岛',
        abbreviationStandard: 'ChST',
        id: 497,
        enabled: true
    },
    {
        name: 'Australia/Hobart',
        displayName: 'GMT+10:00 霍巴特 AEST',
        nameLocalized: '霍巴特',
        abbreviationStandard: 'AEST',
        abbreviationDaylight: 'AEDT',
        id: 317,
        enabled: true
    },
    {
        name: 'Australia/Currie',
        displayName: 'GMT+10:00 库利 AEST',
        nameLocalized: '库利',
        abbreviationStandard: 'AEST',
        abbreviationDaylight: 'AEDT',
        id: 314
    },
    {
        name: 'Australia/Lindeman',
        displayName: 'GMT+10:00 林德曼 AEST',
        nameLocalized: '林德曼',
        abbreviationStandard: 'AEST',
        id: 319
    },
    {
        name: 'Pacific/Port_Moresby',
        displayName: 'GMT+10:00 莫尔兹比港 +10',
        nameLocalized: '莫尔兹比港',
        abbreviationStandard: '+10',
        id: 514
    },
    {
        name: 'Australia/Melbourne',
        displayName: 'GMT+10:00 墨尔本 AEST',
        nameLocalized: '墨尔本',
        abbreviationStandard: 'AEST',
        abbreviationDaylight: 'AEDT',
        id: 321
    },
    {
        name: 'Pacific/Saipan',
        displayName: 'GMT+10:00 塞班 ChST',
        nameLocalized: '塞班',
        abbreviationStandard: 'ChST',
        id: 516
    },
    {
        name: 'Australia/Sydney',
        displayName: 'GMT+10:00 悉尼 AEST',
        nameLocalized: '悉尼',
        abbreviationStandard: 'AEST',
        abbreviationDaylight: 'AEDT',
        id: 327,
        enabled: true
    },
    {
        name: 'Australia/Adelaide',
        displayName: 'GMT+09:30 阿德莱德 ACST',
        nameLocalized: '阿德莱德',
        abbreviationStandard: 'ACST',
        abbreviationDaylight: 'ACDT',
        id: 310,
        enabled: true
    },
    {
        name: 'Australia/Broken_Hill',
        displayName: 'GMT+09:30 布罗肯希尔 ACST',
        nameLocalized: '布罗肯希尔',
        abbreviationStandard: 'ACST',
        abbreviationDaylight: 'ACDT',
        id: 312
    },
    {
        name: 'Australia/Darwin',
        displayName: 'GMT+09:30 达尔文 ACST',
        nameLocalized: '达尔文',
        abbreviationStandard: 'ACST',
        id: 315,
        enabled: true
    },
    {
        name: 'Asia/Jayapura',
        displayName: 'GMT+09:00 查亚普拉 WIT',
        nameLocalized: '查亚普拉',
        abbreviationStandard: 'WIT',
        id: 246
    },
    {
        name: 'Asia/Dili',
        displayName: 'GMT+09:00 帝力 +09',
        nameLocalized: '帝力',
        abbreviationStandard: '+09',
        id: 236
    },
    {
        name: 'Asia/Tokyo',
        displayName: 'GMT+09:00 东京 JST',
        nameLocalized: '东京',
        abbreviationStandard: 'JST',
        id: 287,
        enabled: true
    },
    {
        name: 'Pacific/Palau',
        displayName: 'GMT+09:00 帕劳 +09',
        nameLocalized: '帕劳',
        abbreviationStandard: '+09',
        id: 511
    },
    {
        name: 'Asia/Pyongyang',
        displayName: 'GMT+09:00 平壤 KST',
        nameLocalized: '平壤',
        abbreviationStandard: 'KST',
        id: 269
    },
    {
        name: 'Asia/Seoul',
        displayName: 'GMT+09:00 首尔 KST',
        nameLocalized: '首尔',
        abbreviationStandard: 'KST',
        id: 277,
        enabled: true
    },
    {
        name: 'Asia/Yakutsk',
        displayName: 'GMT+09:00 雅库茨克 +09',
        nameLocalized: '雅库茨克',
        abbreviationStandard: '+09',
        id: 294,
        enabled: true
    },
    {
        name: 'Australia/Eucla',
        displayName: 'GMT+08:45 尤克拉 +0845/+0945',
        nameLocalized: '尤克拉',
        abbreviationStandard: '+0845/+0945',
        id: 316
    },
    {
        name: 'Asia/Macau',
        displayName: 'GMT+08:00 澳门 CST',
        nameLocalized: '澳门',
        abbreviationStandard: 'CST',
        id: 258
    },
    {
        name: 'Asia/Kuching',
        displayName: 'GMT+08:00 古晋 +08',
        nameLocalized: '古晋',
        abbreviationStandard: '+08',
        id: 255
    },
    {
        name: 'Asia/Kuala_Lumpur',
        displayName: 'GMT+08:00 吉隆坡 +08',
        nameLocalized: '吉隆坡',
        abbreviationStandard: '+08',
        id: 254,
        enabled: true
    },
    {
        name: 'Asia/Manila',
        displayName: 'GMT+08:00 马尼拉 PST',
        nameLocalized: '马尼拉',
        abbreviationStandard: 'PST',
        id: 261
    },
    {
        name: 'Australia/Perth',
        displayName: 'GMT+08:00 珀斯 AWST',
        nameLocalized: '珀斯',
        abbreviationStandard: 'AWST',
        id: 324,
        enabled: true
    },
    {
        name: 'Asia/Choibalsan',
        displayName: 'GMT+08:00 乔巴山 +08/+09',
        nameLocalized: '乔巴山',
        abbreviationStandard: '+08/+09',
        id: 229
    },
    {
        name: 'Asia/Shanghai',
        displayName: 'GMT+08:00 上海 CST',
        nameLocalized: '上海',
        abbreviationStandard: 'CST',
        id: 278,
        enabled: true
    },
    {
        name: 'Asia/Taipei',
        displayName: 'GMT+08:00 台北 CST',
        nameLocalized: '台北',
        abbreviationStandard: 'CST',
        id: 280,
        enabled: true
    },
    {
        name: 'Asia/Makassar',
        displayName: 'GMT+08:00 望加锡 WITA',
        nameLocalized: '望加锡',
        abbreviationStandard: 'WITA',
        id: 260
    },
    {
        name: 'Asia/Brunei',
        displayName: 'GMT+08:00 文莱 +08',
        nameLocalized: '文莱',
        abbreviationStandard: '+08',
        id: 227
    },
    {
        name: 'Asia/Ulaanbaatar',
        displayName: 'GMT+08:00 乌兰巴托 +08/+09',
        nameLocalized: '乌兰巴托',
        abbreviationStandard: '+08/+09',
        id: 289,
        enabled: true
    },
    {
        name: 'Asia/Hong_Kong',
        displayName: 'GMT+08:00 香港 HKST',
        nameLocalized: '香港',
        abbreviationStandard: 'HKST',
        id: 241,
        enabled: true
    },
    {
        name: 'Asia/Singapore',
        displayName: 'GMT+08:00 新加坡 +08',
        nameLocalized: '新加坡',
        abbreviationStandard: '+08',
        id: 279
    },
    {
        name: 'Asia/Irkutsk',
        displayName: 'GMT+08:00 伊尔库茨克 +08',
        nameLocalized: '伊尔库茨克',
        abbreviationStandard: '+08',
        id: 243
    },
    {
        name: 'Antarctica/Davis',
        displayName: 'GMT+07:00 戴维斯 +07',
        nameLocalized: '戴维斯',
        abbreviationStandard: '+07',
        id: 203
    },
    {
        name: 'Asia/Saigon',
        displayName: 'GMT+07:00 胡志明市 +07',
        nameLocalized: '胡志明市',
        abbreviationStandard: '+07',
        id: 274
    },
    {
        name: 'Asia/Phnom_Penh',
        displayName: 'GMT+07:00 金边 +07',
        nameLocalized: '金边',
        abbreviationStandard: '+07',
        id: 267
    },
    {
        name: 'Asia/Hovd',
        displayName: 'GMT+07:00 科布多 +07/+08',
        nameLocalized: '科布多',
        abbreviationStandard: '+07/+08',
        id: 242
    },
    {
        name: 'Asia/Krasnoyarsk',
        displayName: 'GMT+07:00 克拉斯诺亚尔斯克 +07',
        nameLocalized: '克拉斯诺亚尔斯克',
        abbreviationStandard: '+07',
        id: 253,
        enabled: true
    },
    {
        name: 'Asia/Pontianak',
        displayName: 'GMT+07:00 坤甸 WIB',
        nameLocalized: '坤甸',
        abbreviationStandard: 'WIB',
        id: 268
    },
    {
        name: 'Asia/Bangkok',
        displayName: 'GMT+07:00 曼谷 +07',
        nameLocalized: '曼谷',
        abbreviationStandard: '+07',
        id: 224,
        enabled: true
    },
    {
        name: 'Asia/Novosibirsk',
        displayName: 'GMT+07:00 诺沃西比尔斯克 +07',
        nameLocalized: '诺沃西比尔斯克',
        abbreviationStandard: '+07',
        id: 264
    },
    {
        name: 'Indian/Christmas',
        displayName: 'GMT+07:00 圣诞岛 +07',
        nameLocalized: '圣诞岛',
        abbreviationStandard: '+07',
        id: 461
    },
    {
        name: 'Asia/Vientiane',
        displayName: 'GMT+07:00 万象 +07',
        nameLocalized: '万象',
        abbreviationStandard: '+07',
        id: 292
    },
    {
        name: 'Asia/Jakarta',
        displayName: 'GMT+07:00 雅加达 WIB',
        nameLocalized: '雅加达',
        abbreviationStandard: 'WIB',
        id: 245
    },
    {
        name: 'Indian/Cocos',
        displayName: 'GMT+06:30 可可斯 +0630',
        nameLocalized: '可可斯',
        abbreviationStandard: '+0630',
        id: 462
    },
    {
        name: 'Asia/Almaty',
        displayName: 'GMT+06:00 阿拉木图 +06',
        nameLocalized: '阿拉木图',
        abbreviationStandard: '+06',
        id: 214,
        enabled: true
    },
    {
        name: 'Asia/Bishkek',
        displayName: 'GMT+06:00 比什凯克 +06',
        nameLocalized: '比什凯克',
        abbreviationStandard: '+06',
        id: 226
    },
    {
        name: 'Indian/Chagos',
        displayName: 'GMT+06:00 查戈斯 +06',
        nameLocalized: '查戈斯',
        abbreviationStandard: '+06',
        id: 460
    },
    {
        name: 'Asia/Dhaka',
        displayName: 'GMT+06:00 达卡 +06/+07',
        nameLocalized: '达卡',
        abbreviationStandard: '+06/+07',
        id: 235,
        enabled: true
    },
    {
        name: 'Asia/Omsk',
        displayName: 'GMT+06:00 鄂木斯克 +06',
        nameLocalized: '鄂木斯克',
        abbreviationStandard: '+06',
        id: 265
    },
    {
        name: 'Asia/Thimphu',
        displayName: 'GMT+06:00 廷布 +06',
        nameLocalized: '廷布',
        abbreviationStandard: '+06',
        id: 286
    },
    {
        name: 'Antarctica/Vostok',
        displayName: 'GMT+06:00 沃斯托克 +06',
        nameLocalized: '沃斯托克',
        abbreviationStandard: '+06',
        id: 211
    },
    {
        name: 'Asia/Urumqi',
        displayName: 'GMT+06:00 乌鲁木齐 +06',
        nameLocalized: '乌鲁木齐',
        abbreviationStandard: '+06',
        id: 291
    },
    {
        name: 'Asia/Colombo',
        displayName: 'GMT+05:30 科伦坡 +0530',
        nameLocalized: '科伦坡',
        abbreviationStandard: '+0530',
        id: 232,
        enabled: true
    },
    {
        name: 'Asia/Aqtau',
        displayName: 'GMT+05:00 阿克套 +05',
        nameLocalized: '阿克套',
        abbreviationStandard: '+05',
        id: 217
    },
    {
        name: 'Asia/Aqtobe',
        displayName: 'GMT+05:00 阿克托别 +05',
        nameLocalized: '阿克托别',
        abbreviationStandard: '+05',
        id: 218
    },
    {
        name: 'Asia/Ashgabat',
        displayName: 'GMT+05:00 阿什哈巴德 +05',
        nameLocalized: '阿什哈巴德',
        abbreviationStandard: '+05',
        id: 219
    },
    {
        name: 'Asia/Dushanbe',
        displayName: 'GMT+05:00 杜尚别 +05',
        nameLocalized: '杜尚别',
        abbreviationStandard: '+05',
        id: 238
    },
    {
        name: 'Asia/Karachi',
        displayName: 'GMT+05:00 卡拉奇 PKST',
        nameLocalized: '卡拉奇',
        abbreviationStandard: 'PKST',
        id: 250,
        enabled: true
    },
    {
        name: 'Indian/Kerguelen',
        displayName: 'GMT+05:00 凯尔盖朗 +05',
        nameLocalized: '凯尔盖朗',
        abbreviationStandard: '+05',
        id: 464
    },
    {
        name: 'Asia/Qyzylorda',
        displayName: 'GMT+05:00 克孜洛尔达 +05',
        nameLocalized: '克孜洛尔达',
        abbreviationStandard: '+05',
        id: 271
    },
    {
        name: 'Indian/Maldives',
        displayName: 'GMT+05:00 马尔代夫 +05',
        nameLocalized: '马尔代夫',
        abbreviationStandard: '+05',
        id: 466
    },
    {
        name: 'Antarctica/Mawson',
        displayName: 'GMT+05:00 莫森 +05',
        nameLocalized: '莫森',
        abbreviationStandard: '+05',
        id: 205
    },
    {
        name: 'Asia/Samarkand',
        displayName: 'GMT+05:00 撒马尔罕 +05',
        nameLocalized: '撒马尔罕',
        abbreviationStandard: '+05',
        id: 276
    },
    {
        name: 'Asia/Tashkent',
        displayName: 'GMT+05:00 塔什干 +05',
        nameLocalized: '塔什干',
        abbreviationStandard: '+05',
        id: 281
    },
    {
        name: 'Asia/Oral',
        displayName: 'GMT+05:00 乌拉尔 +05',
        nameLocalized: '乌拉尔',
        abbreviationStandard: '+05',
        id: 266
    },
    {
        name: 'Asia/Yekaterinburg',
        displayName: 'GMT+05:00 叶卡捷琳堡 +05',
        nameLocalized: '叶卡捷琳堡',
        abbreviationStandard: '+05',
        id: 295,
        enabled: true
    },
    {
        name: 'Asia/Kabul',
        displayName: 'GMT+04:30 喀布尔 +0430',
        nameLocalized: '喀布尔',
        abbreviationStandard: '+0430',
        id: 248,
        enabled: true
    },
    {
        name: 'Asia/Yerevan',
        displayName: 'GMT+04:00 埃里温 +04/+05',
        nameLocalized: '埃里温',
        abbreviationStandard: '+04/+05',
        id: 296,
        enabled: true
    },
    {
        name: 'Asia/Baku',
        displayName: 'GMT+04:00 巴库 +04/+05',
        nameLocalized: '巴库',
        abbreviationStandard: '+04/+05',
        id: 223,
        enabled: true
    },
    {
        name: 'Asia/Dubai',
        displayName: 'GMT+04:00 迪拜 +04',
        nameLocalized: '迪拜',
        abbreviationStandard: '+04',
        id: 237
    },
    {
        name: 'Asia/Tbilisi',
        displayName: 'GMT+04:00 第比利斯 +04',
        nameLocalized: '第比利斯',
        abbreviationStandard: '+04',
        id: 282,
        enabled: true
    },
    {
        name: 'Indian/Reunion',
        displayName: 'GMT+04:00 留尼汪 +04',
        nameLocalized: '留尼汪',
        abbreviationStandard: '+04',
        id: 469
    },
    {
        name: 'Indian/Mahe',
        displayName: 'GMT+04:00 马埃岛 +04',
        nameLocalized: '马埃岛',
        abbreviationStandard: '+04',
        id: 465
    },
    {
        name: 'Asia/Muscat',
        displayName: 'GMT+04:00 马斯喀特 +04',
        nameLocalized: '马斯喀特',
        abbreviationStandard: '+04',
        id: 262,
        enabled: true
    },
    {
        name: 'Indian/Mauritius',
        displayName: 'GMT+04:00 毛里求斯 +04/+05',
        nameLocalized: '毛里求斯',
        abbreviationStandard: '+04/+05',
        id: 467
    },
    {
        name: 'Europe/Samara',
        displayName: 'GMT+04:00 萨马拉 +04',
        nameLocalized: '萨马拉',
        abbreviationStandard: '+04',
        id: 428
    },
    {
        name: 'Asia/Tehran',
        displayName: 'GMT+03:30 德黑兰 +0330/+0430',
        nameLocalized: '德黑兰',
        abbreviationStandard: '+0330/+0430',
        abbreviationDaylight: '+0330/+0430',
        id: 283,
        enabled: true
    },
    {
        name: 'Africa/Asmera',
        displayName: 'GMT+03:00 阿斯马拉 EAT',
        nameLocalized: '阿斯马拉',
        abbreviationStandard: 'EAT',
        id: 6
    },
    {
        name: 'Indian/Antananarivo',
        displayName: 'GMT+03:00 安塔那那利佛 EAT',
        nameLocalized: '安塔那那利佛',
        abbreviationStandard: 'EAT',
        id: 459
    },
    {
        name: 'Asia/Baghdad',
        displayName: 'GMT+03:00 巴格达 +03/+04',
        nameLocalized: '巴格达',
        abbreviationStandard: '+03/+04',
        id: 221,
        enabled: true
    },
    {
        name: 'Asia/Bahrain',
        displayName: 'GMT+03:00 巴林 +03',
        nameLocalized: '巴林',
        abbreviationStandard: '+03',
        id: 222
    },
    {
        name: 'Africa/Dar_es_Salaam',
        displayName: 'GMT+03:00 达累斯萨拉姆 EAT',
        nameLocalized: '达累斯萨拉姆',
        abbreviationStandard: 'EAT',
        id: 19
    },
    {
        name: 'Europe/Volgograd',
        displayName: 'GMT+03:00 伏尔加格勒 +03',
        nameLocalized: '伏尔加格勒',
        abbreviationStandard: '+03',
        id: 443
    },
    {
        name: 'Africa/Djibouti',
        displayName: 'GMT+03:00 吉布提 EAT',
        nameLocalized: '吉布提',
        abbreviationStandard: 'EAT',
        id: 20
    },
    {
        name: 'Asia/Qatar',
        displayName: 'GMT+03:00 卡塔尔 +03',
        nameLocalized: '卡塔尔',
        abbreviationStandard: '+03',
        id: 270
    },
    {
        name: 'Africa/Kampala',
        displayName: 'GMT+03:00 坎帕拉 EAT',
        nameLocalized: '坎帕拉',
        abbreviationStandard: 'EAT',
        id: 27
    },
    {
        name: 'Indian/Comoro',
        displayName: 'GMT+03:00 科摩罗 EAT',
        nameLocalized: '科摩罗',
        abbreviationStandard: 'EAT',
        id: 463
    },
    {
        name: 'Asia/Kuwait',
        displayName: 'GMT+03:00 科威特 +03',
        nameLocalized: '科威特',
        abbreviationStandard: '+03',
        id: 256,
        enabled: true
    },
    {
        name: 'Asia/Riyadh',
        displayName: 'GMT+03:00 利雅得 +03',
        nameLocalized: '利雅得',
        abbreviationStandard: '+03',
        id: 273
    },
    {
        name: 'Indian/Mayotte',
        displayName: 'GMT+03:00 马约特 EAT',
        nameLocalized: '马约特',
        abbreviationStandard: 'EAT',
        id: 468
    },
    {
        name: 'Europe/Minsk',
        displayName: 'GMT+03:00 明斯克 +03',
        nameLocalized: '明斯克',
        abbreviationStandard: '+03',
        id: 418,
        enabled: true
    },
    {
        name: 'Africa/Mogadishu',
        displayName: 'GMT+03:00 摩加迪沙 EAT',
        nameLocalized: '摩加迪沙',
        abbreviationStandard: 'EAT',
        id: 41
    },
    {
        name: 'Europe/Moscow',
        displayName: 'GMT+03:00 莫斯科 MSK',
        nameLocalized: '莫斯科',
        abbreviationStandard: 'MSK',
        id: 420,
        enabled: true
    },
    {
        name: 'Africa/Nairobi',
        displayName: 'GMT+03:00 内罗毕 EAT',
        nameLocalized: '内罗毕',
        abbreviationStandard: 'EAT',
        id: 43,
        enabled: true
    },
    {
        name: 'Europe/Simferopol',
        displayName: 'GMT+03:00 辛菲罗波尔 MSK',
        nameLocalized: '辛菲罗波尔',
        abbreviationStandard: 'MSK',
        id: 431
    },
    {
        name: 'Africa/Addis_Ababa',
        displayName: 'GMT+03:00 亚的斯亚贝巴 EAT',
        nameLocalized: '亚的斯亚贝巴',
        abbreviationStandard: 'EAT',
        id: 3
    },
    {
        name: 'Asia/Aden',
        displayName: 'GMT+03:00 亚丁 +03',
        nameLocalized: '亚丁',
        abbreviationStandard: '+03',
        id: 213
    },
    {
        name: 'Europe/Istanbul',
        displayName: 'GMT+03:00 伊斯坦布尔 +03',
        nameLocalized: '伊斯坦布尔',
        abbreviationStandard: '+03',
        id: 244,
        enabled: true
    },
    {
        name: 'Antarctica/Syowa',
        displayName: 'GMT+03:00 昭和 +03',
        nameLocalized: '昭和',
        abbreviationStandard: '+03',
        id: 210
    },
    {
        name: 'Asia/Amman',
        displayName: 'GMT+02:00 安曼 EET',
        nameLocalized: '安曼',
        abbreviationStandard: 'EET',
        abbreviationDaylight: 'EEST',
        id: 215,
        enabled: true
    },
    {
        name: 'Asia/Beirut',
        displayName: 'GMT+02:00 贝鲁特 EET',
        nameLocalized: '贝鲁特',
        abbreviationStandard: 'EET',
        abbreviationDaylight: 'EEST',
        id: 225,
        enabled: true
    },
    {
        name: 'Europe/Bucharest',
        displayName: 'GMT+02:00 布加勒斯特 EET',
        nameLocalized: '布加勒斯特',
        abbreviationStandard: 'EET',
        abbreviationDaylight: 'EEST',
        id: 398
    },
    {
        name: 'Africa/Blantyre',
        displayName: 'GMT+02:00 布兰太尔 CAT',
        nameLocalized: '布兰太尔',
        abbreviationStandard: 'CAT',
        id: 11
    },
    {
        name: 'Africa/Bujumbura',
        displayName: 'GMT+02:00 布琼布拉 CAT',
        nameLocalized: '布琼布拉',
        abbreviationStandard: 'CAT',
        id: 13
    },
    {
        name: 'Asia/Damascus',
        displayName: 'GMT+02:00 大马士革 EET',
        nameLocalized: '大马士革',
        abbreviationStandard: 'EET',
        abbreviationDaylight: 'EEST',
        id: 234
    },
    {
        name: 'Africa/Tripoli',
        displayName: 'GMT+02:00 的黎波里 EET',
        nameLocalized: '的黎波里',
        abbreviationStandard: 'EET',
        id: 51
    },
    {
        name: 'Africa/Gaborone',
        displayName: 'GMT+02:00 哈博罗内 CAT',
        nameLocalized: '哈博罗内',
        abbreviationStandard: 'CAT',
        id: 24
    },
    {
        name: 'Africa/Harare',
        displayName: 'GMT+02:00 哈拉雷 CAT',
        nameLocalized: '哈拉雷',
        abbreviationStandard: 'CAT',
        id: 25,
        enabled: true
    },
    {
        name: 'Europe/Helsinki',
        displayName: 'GMT+02:00 赫尔辛基 EET',
        nameLocalized: '赫尔辛基',
        abbreviationStandard: 'EET',
        abbreviationDaylight: 'EEST',
        id: 405,
        enabled: true
    },
    {
        name: 'Europe/Kiev',
        displayName: 'GMT+02:00 基辅 EET',
        nameLocalized: '基辅',
        abbreviationStandard: 'EET',
        abbreviationDaylight: 'EEST',
        id: 410
    },
    {
        name: 'Africa/Kigali',
        displayName: 'GMT+02:00 基加利 CAT',
        nameLocalized: '基加利',
        abbreviationStandard: 'CAT',
        id: 29
    },
    {
        name: 'Europe/Chisinau',
        displayName: 'GMT+02:00 基希讷乌 EET',
        nameLocalized: '基希讷乌',
        abbreviationStandard: 'EET',
        abbreviationDaylight: 'EEST',
        id: 400
    },
    {
        name: 'Europe/Kaliningrad',
        displayName: 'GMT+02:00 加里宁格勒 EET',
        nameLocalized: '加里宁格勒',
        abbreviationStandard: 'EET',
        id: 409
    },
    {
        name: 'Asia/Gaza',
        displayName: 'GMT+02:00 加沙 EET',
        nameLocalized: '加沙',
        abbreviationStandard: 'EET',
        abbreviationDaylight: 'EEST',
        id: 239
    },
    {
        name: 'Africa/Khartoum',
        displayName: 'GMT+02:00 喀土穆 CAT',
        nameLocalized: '喀土穆',
        abbreviationStandard: 'CAT',
        id: 28
    },
    {
        name: 'Africa/Cairo',
        displayName: 'GMT+02:00 开罗 EEST',
        nameLocalized: '开罗',
        abbreviationStandard: 'EEST',
        id: 14,
        enabled: true
    },
    {
        name: 'Europe/Riga',
        displayName: 'GMT+02:00 里加 EET',
        nameLocalized: '里加',
        abbreviationStandard: 'EET',
        abbreviationDaylight: 'EEST',
        id: 426
    },
    {
        name: 'Africa/Lubumbashi',
        displayName: 'GMT+02:00 卢本巴希 CAT',
        nameLocalized: '卢本巴希',
        abbreviationStandard: 'CAT',
        id: 35
    },
    {
        name: 'Africa/Lusaka',
        displayName: 'GMT+02:00 卢萨卡 CAT',
        nameLocalized: '卢萨卡',
        abbreviationStandard: 'CAT',
        id: 36
    },
    {
        name: 'Africa/Maputo',
        displayName: 'GMT+02:00 马普托 CAT',
        nameLocalized: '马普托',
        abbreviationStandard: 'CAT',
        id: 38
    },
    {
        name: 'Africa/Maseru',
        displayName: 'GMT+02:00 马塞卢 SAST',
        nameLocalized: '马塞卢',
        abbreviationStandard: 'SAST',
        id: 39
    },
    {
        name: 'Europe/Mariehamn',
        displayName: 'GMT+02:00 玛丽港 EET',
        nameLocalized: '玛丽港',
        abbreviationStandard: 'EET',
        abbreviationDaylight: 'EEST',
        id: 417
    },
    {
        name: 'Africa/Mbabane',
        displayName: 'GMT+02:00 姆巴巴纳 SAST',
        nameLocalized: '姆巴巴纳',
        abbreviationStandard: 'SAST',
        id: 40
    },
    {
        name: 'Asia/Nicosia',
        displayName: 'GMT+02:00 尼科西亚 EET',
        nameLocalized: '尼科西亚',
        abbreviationStandard: 'EET',
        abbreviationDaylight: 'EEST',
        id: 263
    },
    {
        name: 'Europe/Sofia',
        displayName: 'GMT+02:00 索非亚 EET',
        nameLocalized: '索非亚',
        abbreviationStandard: 'EET',
        abbreviationDaylight: 'EEST',
        id: 433
    },
    {
        name: 'Europe/Tallinn',
        displayName: 'GMT+02:00 塔林 EET',
        nameLocalized: '塔林',
        abbreviationStandard: 'EET',
        abbreviationDaylight: 'EEST',
        id: 435
    },
    {
        name: 'Europe/Vilnius',
        displayName: 'GMT+02:00 维尔纽斯 EET',
        nameLocalized: '维尔纽斯',
        abbreviationStandard: 'EET',
        abbreviationDaylight: 'EEST',
        id: 442
    },
    {
        name: 'Africa/Windhoek',
        displayName: 'GMT+02:00 温得和克 WAT',
        nameLocalized: '温得和克',
        abbreviationStandard: 'WAT',
        id: 53,
        enabled: true
    },
    {
        name: 'Europe/Uzhgorod',
        displayName: 'GMT+02:00 乌日哥罗德 EET',
        nameLocalized: '乌日哥罗德',
        abbreviationStandard: 'EET',
        abbreviationDaylight: 'EEST',
        id: 438
    },
    {
        name: 'Europe/Athens',
        displayName: 'GMT+02:00 雅典 EET',
        nameLocalized: '雅典',
        abbreviationStandard: 'EET',
        abbreviationDaylight: 'EEST',
        id: 392
    },
    {
        name: 'Asia/Jerusalem',
        displayName: 'GMT+02:00 耶路撒冷 IST',
        nameLocalized: '耶路撒冷',
        abbreviationStandard: 'IST',
        abbreviationDaylight: 'IDT',
        id: 247,
        enabled: true
    },
    {
        name: 'Africa/Johannesburg',
        displayName: 'GMT+02:00 约翰内斯堡 SAST',
        nameLocalized: '约翰内斯堡',
        abbreviationStandard: 'SAST',
        id: 26
    },
    {
        name: 'Europe/Zaporozhye',
        displayName: 'GMT+02:00 扎波罗热 EET',
        nameLocalized: '扎波罗热',
        abbreviationStandard: 'EET',
        abbreviationDaylight: 'EEST',
        id: 446
    },
    {
        name: 'Africa/Algiers',
        displayName: 'GMT+01:00 阿尔及尔 CET',
        nameLocalized: '阿尔及尔',
        abbreviationStandard: 'CET',
        id: 4
    },
    {
        name: 'Europe/Amsterdam',
        displayName: 'GMT+01:00 阿姆斯特丹 CET',
        nameLocalized: '阿姆斯特丹',
        abbreviationStandard: 'CET',
        abbreviationDaylight: 'CEST',
        id: 390,
        enabled: true
    },
    {
        name: 'Africa/El_Aaiun',
        displayName: 'GMT+01:00 阿尤恩 +01/+00',
        nameLocalized: '阿尤恩',
        abbreviationStandard: '+01/+00',
        id: 22
    },
    {
        name: 'Europe/Andorra',
        displayName: 'GMT+01:00 安道尔 CET',
        nameLocalized: '安道尔',
        abbreviationStandard: 'CET',
        abbreviationDaylight: 'CEST',
        id: 391
    },
    {
        name: 'Europe/Oslo',
        displayName: 'GMT+01:00 奥斯陆 CET',
        nameLocalized: '奥斯陆',
        abbreviationStandard: 'CET',
        abbreviationDaylight: 'CEST',
        id: 422
    },
    {
        name: 'Europe/Paris',
        displayName: 'GMT+01:00 巴黎 CET',
        nameLocalized: '巴黎',
        abbreviationStandard: 'CET',
        abbreviationDaylight: 'CEST',
        id: 423
    },
    {
        name: 'Europe/Berlin',
        displayName: 'GMT+01:00 柏林 CET',
        nameLocalized: '柏林',
        abbreviationStandard: 'CET',
        abbreviationDaylight: 'CEST',
        id: 395
    },
    {
        name: 'Africa/Bangui',
        displayName: 'GMT+01:00 班吉 WAT',
        nameLocalized: '班吉',
        abbreviationStandard: 'WAT',
        id: 8
    },
    {
        name: 'Europe/Belgrade',
        displayName: 'GMT+01:00 贝尔格莱德 CET',
        nameLocalized: '贝尔格莱德',
        abbreviationStandard: 'CET',
        abbreviationDaylight: 'CEST',
        id: 394
    },
    {
        name: 'Europe/Podgorica',
        displayName: 'GMT+01:00 波德戈里察 CET',
        nameLocalized: '波德戈里察',
        abbreviationStandard: 'CET',
        abbreviationDaylight: 'CEST',
        id: 424
    },
    {
        name: 'Africa/Porto-Novo',
        displayName: 'GMT+01:00 波多诺伏 WAT',
        nameLocalized: '波多诺伏',
        abbreviationStandard: 'WAT',
        id: 48,
        enabled: true
    },
    {
        name: 'Europe/Budapest',
        displayName: 'GMT+01:00 布达佩斯 CET',
        nameLocalized: '布达佩斯',
        abbreviationStandard: 'CET',
        abbreviationDaylight: 'CEST',
        id: 399,
        enabled: true
    },
    {
        name: 'Africa/Brazzaville',
        displayName: 'GMT+01:00 布拉柴维尔 WAT',
        nameLocalized: '布拉柴维尔',
        abbreviationStandard: 'WAT',
        id: 12
    },
    {
        name: 'Europe/Bratislava',
        displayName: 'GMT+01:00 布拉迪斯拉发 CET',
        nameLocalized: '布拉迪斯拉发',
        abbreviationStandard: 'CET',
        abbreviationDaylight: 'CEST',
        id: 396
    },
    {
        name: 'Europe/Prague',
        displayName: 'GMT+01:00 布拉格 CET',
        nameLocalized: '布拉格',
        abbreviationStandard: 'CET',
        abbreviationDaylight: 'CEST',
        id: 425
    },
    {
        name: 'Europe/Brussels',
        displayName: 'GMT+01:00 布鲁塞尔 CET',
        nameLocalized: '布鲁塞尔',
        abbreviationStandard: 'CET',
        abbreviationDaylight: 'CEST',
        id: 397
    },
    {
        name: 'Europe/Tirane',
        displayName: 'GMT+01:00 地拉那 CET',
        nameLocalized: '地拉那',
        abbreviationStandard: 'CET',
        abbreviationDaylight: 'CEST',
        id: 436
    },
    {
        name: 'Europe/Dublin',
        displayName: 'GMT+01:00 都柏林 IST/GMT',
        nameLocalized: '都柏林',
        abbreviationStandard: 'IST/GMT',
        id: 402
    },
    {
        name: 'Africa/Douala',
        displayName: 'GMT+01:00 杜阿拉 WAT',
        nameLocalized: '杜阿拉',
        abbreviationStandard: 'WAT',
        id: 21
    },
    {
        name: 'Africa/Ndjamena',
        displayName: 'GMT+01:00 恩贾梅纳 WAT',
        nameLocalized: '恩贾梅纳',
        abbreviationStandard: 'WAT',
        id: 44
    },
    {
        name: 'Europe/Vatican',
        displayName: 'GMT+01:00 梵蒂冈 CET',
        nameLocalized: '梵蒂冈',
        abbreviationStandard: 'CET',
        abbreviationDaylight: 'CEST',
        id: 440
    },
    {
        name: 'Europe/Copenhagen',
        displayName: 'GMT+01:00 哥本哈根 CET',
        nameLocalized: '哥本哈根',
        abbreviationStandard: 'CET',
        abbreviationDaylight: 'CEST',
        id: 401
    },
    {
        name: 'Europe/Warsaw',
        displayName: 'GMT+01:00 华沙 CET',
        nameLocalized: '华沙',
        abbreviationStandard: 'CET',
        abbreviationDaylight: 'CEST',
        id: 444
    },
    {
        name: 'Africa/Kinshasa',
        displayName: 'GMT+01:00 金沙萨 WAT',
        nameLocalized: '金沙萨',
        abbreviationStandard: 'WAT',
        id: 30
    },
    {
        name: 'Africa/Casablanca',
        displayName: 'GMT+01:00 卡萨布兰卡 +01/+00',
        nameLocalized: '卡萨布兰卡',
        abbreviationStandard: '+01/+00',
        id: 15,
        enabled: true
    },
    {
        name: 'Africa/Lagos',
        displayName: 'GMT+01:00 拉各斯 WAT',
        nameLocalized: '拉各斯',
        abbreviationStandard: 'WAT',
        id: 31
    },
    {
        name: 'Arctic/Longyearbyen',
        displayName: 'GMT+01:00 朗伊尔城 CET',
        nameLocalized: '朗伊尔城',
        abbreviationStandard: 'CET',
        abbreviationDaylight: 'CEST',
        id: 212
    },
    {
        name: 'Africa/Libreville',
        displayName: 'GMT+01:00 利伯维尔 WAT',
        nameLocalized: '利伯维尔',
        abbreviationStandard: 'WAT',
        id: 32
    },
    {
        name: 'Europe/Ljubljana',
        displayName: 'GMT+01:00 卢布尔雅那 CET',
        nameLocalized: '卢布尔雅那',
        abbreviationStandard: 'CET',
        abbreviationDaylight: 'CEST',
        id: 412
    },
    {
        name: 'Europe/Luxembourg',
        displayName: 'GMT+01:00 卢森堡 CET',
        nameLocalized: '卢森堡',
        abbreviationStandard: 'CET',
        abbreviationDaylight: 'CEST',
        id: 414
    },
    {
        name: 'Africa/Luanda',
        displayName: 'GMT+01:00 罗安达 WAT',
        nameLocalized: '罗安达',
        abbreviationStandard: 'WAT',
        id: 34
    },
    {
        name: 'Europe/Rome',
        displayName: 'GMT+01:00 罗马 CET',
        nameLocalized: '罗马',
        abbreviationStandard: 'CET',
        abbreviationDaylight: 'CEST',
        id: 427
    },
    {
        name: 'Europe/Madrid',
        displayName: 'GMT+01:00 马德里 CET',
        nameLocalized: '马德里',
        abbreviationStandard: 'CET',
        abbreviationDaylight: 'CEST',
        id: 415,
        enabled: true
    },
    {
        name: 'Europe/Malta',
        displayName: 'GMT+01:00 马耳他 CET',
        nameLocalized: '马耳他',
        abbreviationStandard: 'CET',
        abbreviationDaylight: 'CEST',
        id: 416
    },
    {
        name: 'Africa/Malabo',
        displayName: 'GMT+01:00 马拉博 WAT',
        nameLocalized: '马拉博',
        abbreviationStandard: 'WAT',
        id: 37
    },
    {
        name: 'Europe/Monaco',
        displayName: 'GMT+01:00 摩纳哥 CET',
        nameLocalized: '摩纳哥',
        abbreviationStandard: 'CET',
        abbreviationDaylight: 'CEST',
        id: 419
    },
    {
        name: 'Africa/Niamey',
        displayName: 'GMT+01:00 尼亚美 WAT',
        nameLocalized: '尼亚美',
        abbreviationStandard: 'WAT',
        id: 45
    },
    {
        name: 'Europe/Zagreb',
        displayName: 'GMT+01:00 萨格勒布 CET',
        nameLocalized: '萨格勒布',
        abbreviationStandard: 'CET',
        abbreviationDaylight: 'CEST',
        id: 445
    },
    {
        name: 'Europe/Sarajevo',
        displayName: 'GMT+01:00 萨拉热窝 CET',
        nameLocalized: '萨拉热窝',
        abbreviationStandard: 'CET',
        abbreviationDaylight: 'CEST',
        id: 430,
        enabled: true
    },
    {
        name: 'Europe/San_Marino',
        displayName: 'GMT+01:00 圣马力诺 CET',
        nameLocalized: '圣马力诺',
        abbreviationStandard: 'CET',
        abbreviationDaylight: 'CEST',
        id: 429
    },
    {
        name: 'Europe/Stockholm',
        displayName: 'GMT+01:00 斯德哥尔摩 CET',
        nameLocalized: '斯德哥尔摩',
        abbreviationStandard: 'CET',
        abbreviationDaylight: 'CEST',
        id: 434
    },
    {
        name: 'Europe/Skopje',
        displayName: 'GMT+01:00 斯科普里 CET',
        nameLocalized: '斯科普里',
        abbreviationStandard: 'CET',
        abbreviationDaylight: 'CEST',
        id: 432
    },
    {
        name: 'Europe/Zurich',
        displayName: 'GMT+01:00 苏黎世 CET',
        nameLocalized: '苏黎世',
        abbreviationStandard: 'CET',
        abbreviationDaylight: 'CEST',
        id: 447
    },
    {
        name: 'Africa/Tunis',
        displayName: 'GMT+01:00 突尼斯 CEST',
        nameLocalized: '突尼斯',
        abbreviationStandard: 'CEST',
        id: 52
    },
    {
        name: 'Europe/Vaduz',
        displayName: 'GMT+01:00 瓦杜兹 CET',
        nameLocalized: '瓦杜兹',
        abbreviationStandard: 'CET',
        abbreviationDaylight: 'CEST',
        id: 439
    },
    {
        name: 'Europe/Vienna',
        displayName: 'GMT+01:00 维也纳 CET',
        nameLocalized: '维也纳',
        abbreviationStandard: 'CET',
        abbreviationDaylight: 'CEST',
        id: 441
    },
    {
        name: 'Africa/Ceuta',
        displayName: 'GMT+01:00 休达 CET',
        nameLocalized: '休达',
        abbreviationStandard: 'CET',
        abbreviationDaylight: 'CEST',
        id: 16
    },
    {
        name: 'Europe/Gibraltar',
        displayName: 'GMT+01:00 直布罗陀 CET',
        nameLocalized: '直布罗陀',
        abbreviationStandard: 'CET',
        abbreviationDaylight: 'CEST',
        id: 403
    },
    {
        name: 'Africa/Abidjan',
        displayName: 'GMT+00:00 阿比让 GMT',
        nameLocalized: '阿比让',
        abbreviationStandard: 'GMT',
        id: 1
    },
    {
        name: 'Africa/Accra',
        displayName: 'GMT+00:00 阿克拉 GMT',
        nameLocalized: '阿克拉',
        abbreviationStandard: 'GMT',
        id: 2
    },
    {
        name: 'Africa/Bamako',
        displayName: 'GMT+00:00 巴马科 GMT',
        nameLocalized: '巴马科',
        abbreviationStandard: 'GMT',
        id: 7
    },
    {
        name: 'Africa/Banjul',
        displayName: 'GMT+00:00 班珠尔 GMT',
        nameLocalized: '班珠尔',
        abbreviationStandard: 'GMT',
        id: 9
    },
    {
        name: 'Africa/Bissau',
        displayName: 'GMT+00:00 比绍 GMT',
        nameLocalized: '比绍',
        abbreviationStandard: 'GMT',
        id: 10
    },
    {
        name: 'Pacific/Ponape',
        displayName: 'GMT+00:00 波纳佩岛 UTC',
        nameLocalized: '波纳佩岛',
        abbreviationStandard: 'UTC',
        id: 513
    },
    {
        name: 'Africa/Dakar',
        displayName: 'GMT+00:00 达喀尔 GMT',
        nameLocalized: '达喀尔',
        abbreviationStandard: 'GMT',
        id: 18
    },
    {
        name: 'America/Danmarkshavn',
        displayName: 'GMT+00:00 丹马沙文 GMT',
        nameLocalized: '丹马沙文',
        abbreviationStandard: 'GMT',
        id: 97
    },
    {
        name: 'Pacific/Enderbury',
        displayName: 'GMT+00:00 恩德伯里 -00',
        nameLocalized: '恩德伯里',
        abbreviationStandard: '-00',
        id: 490
    },
    {
        name: 'Atlantic/Faeroe',
        displayName: 'GMT+00:00 法罗 UTC',
        nameLocalized: '法罗',
        abbreviationStandard: 'UTC',
        id: 301
    },
    {
        name: 'Africa/Freetown',
        displayName: 'GMT+00:00 弗里敦 GMT',
        nameLocalized: '弗里敦',
        abbreviationStandard: 'GMT',
        id: 23
    },
    {
        name: 'Europe/Guernsey',
        displayName: 'GMT+00:00 根西岛 GMT/BST',
        nameLocalized: '根西岛',
        abbreviationStandard: 'GMT/BST',
        abbreviationDaylight: 'GMT/BST',
        id: 404
    },
    {
        name: 'Asia/Katmandu',
        displayName: 'GMT+00:00 加德满都 UTC',
        nameLocalized: '加德满都',
        abbreviationStandard: 'UTC',
        id: 252,
        enabled: true
    },
    {
        name: 'Asia/Calcutta',
        displayName: 'GMT+00:00 加尔各答 UTC',
        nameLocalized: '加尔各答',
        abbreviationStandard: 'UTC',
        id: 228,
        enabled: true
    },
    {
        name: 'Atlantic/Canary',
        displayName: 'GMT+00:00 加那利 WET',
        nameLocalized: '加那利',
        abbreviationStandard: 'WET',
        abbreviationDaylight: 'WEST',
        id: 299
    },
    {
        name: 'Africa/Conakry',
        displayName: 'GMT+00:00 科纳克里 GMT',
        nameLocalized: '科纳克里',
        abbreviationStandard: 'GMT',
        id: 17
    },
    {
        name: 'Atlantic/Reykjavik',
        displayName: 'GMT+00:00 雷克雅未克 GMT',
        nameLocalized: '雷克雅未克',
        abbreviationStandard: 'GMT',
        id: 305
    },
    {
        name: 'Europe/Lisbon',
        displayName: 'GMT+00:00 里斯本 WET',
        nameLocalized: '里斯本',
        abbreviationStandard: 'WET',
        abbreviationDaylight: 'WEST',
        id: 411
    },
    {
        name: 'Europe/London',
        displayName: 'GMT+00:00 伦敦 GMT/BST',
        nameLocalized: '伦敦',
        abbreviationStandard: 'GMT/BST',
        abbreviationDaylight: 'GMT/BST',
        id: 413,
        enabled: true
    },
    {
        name: 'Africa/Lome',
        displayName: 'GMT+00:00 洛美 GMT',
        nameLocalized: '洛美',
        abbreviationStandard: 'GMT',
        id: 33
    },
    {
        name: 'Atlantic/Madeira',
        displayName: 'GMT+00:00 马德拉 WET',
        nameLocalized: '马德拉',
        abbreviationStandard: 'WET',
        abbreviationDaylight: 'WEST',
        id: 304
    },
    {
        name: 'Europe/Isle_of_Man',
        displayName: 'GMT+00:00 曼岛 GMT/BST',
        nameLocalized: '曼岛',
        abbreviationStandard: 'GMT/BST',
        abbreviationDaylight: 'GMT/BST',
        id: 406
    },
    {
        name: 'Africa/Monrovia',
        displayName: 'GMT+00:00 蒙罗维亚 GMT',
        nameLocalized: '蒙罗维亚',
        abbreviationStandard: 'GMT',
        id: 42
    },
    {
        name: 'Africa/Nouakchott',
        displayName: 'GMT+00:00 努瓦克肖特 GMT',
        nameLocalized: '努瓦克肖特',
        abbreviationStandard: 'GMT',
        id: 46
    },
    {
        name: 'Africa/Sao_Tome',
        displayName: 'GMT+00:00 圣多美 GMT',
        nameLocalized: '圣多美',
        abbreviationStandard: 'GMT',
        id: 49
    },
    {
        name: 'Atlantic/St_Helena',
        displayName: 'GMT+00:00 圣赫勒拿 GMT',
        nameLocalized: '圣赫勒拿',
        abbreviationStandard: 'GMT',
        id: 307
    },
    {
        name: 'Pacific/Truk',
        displayName: 'GMT+00:00 特鲁克群岛 UTC',
        nameLocalized: '特鲁克群岛',
        abbreviationStandard: 'UTC',
        id: 521
    },
    {
        name: 'Africa/Ouagadougou',
        displayName: 'GMT+00:00 瓦加杜古 GMT',
        nameLocalized: '瓦加杜古',
        abbreviationStandard: 'GMT',
        id: 47
    },
    {
        name: 'Asia/Rangoon',
        displayName: 'GMT+00:00 仰光 UTC',
        nameLocalized: '仰光',
        abbreviationStandard: 'UTC',
        id: 272,
        enabled: true
    },
    {
        name: 'Europe/Jersey',
        displayName: 'GMT+00:00 泽西岛 GMT/BST',
        nameLocalized: '泽西岛',
        abbreviationStandard: 'GMT/BST',
        abbreviationDaylight: 'GMT/BST',
        id: 408
    },
    {
        name: 'Etc/UTC',
        displayName: 'GMT+00:00 UTC UTC',
        nameLocalized: 'UTC',
        abbreviationStandard: 'UTC',
        id: 388
    },
    {
        name: 'Atlantic/Cape_Verde',
        displayName: 'GMT-01:00 佛得角 -01',
        nameLocalized: '佛得角',
        abbreviationStandard: '-01',
        id: 300,
        enabled: true
    },
    {
        name: 'America/Scoresbysund',
        displayName: 'GMT-01:00 斯科列斯比桑德 -01/+00',
        nameLocalized: '斯科列斯比桑德',
        abbreviationStandard: '-01/+00',
        abbreviationDaylight: '-01/+00',
        id: 182
    },
    {
        name: 'Atlantic/Azores',
        displayName: 'GMT-01:00 亚速尔群岛 -01/+00',
        nameLocalized: '亚速尔群岛',
        abbreviationStandard: '-01/+00',
        abbreviationDaylight: '-01/+00',
        id: 297,
        enabled: true
    },
    {
        name: 'America/Noronha',
        displayName: 'GMT-02:00 洛罗尼亚 -02',
        nameLocalized: '洛罗尼亚',
        abbreviationStandard: '-02',
        id: 160
    },
    {
        name: 'Atlantic/South_Georgia',
        displayName: 'GMT-02:00 南乔治亚 -02',
        nameLocalized: '南乔治亚',
        abbreviationStandard: '-02',
        id: 306,
        enabled: true
    },
    {
        name: 'America/St_Johns',
        displayName: 'GMT-03:30 圣约翰斯 NST',
        nameLocalized: '圣约翰斯',
        abbreviationStandard: 'NST',
        abbreviationDaylight: 'NDT',
        id: 184,
        enabled: true
    },
    {
        name: 'America/Araguaina',
        displayName: 'GMT-03:00 阿拉瓜伊纳 -03',
        nameLocalized: '阿拉瓜伊纳',
        abbreviationStandard: '-03',
        id: 58
    },
    {
        name: 'America/Bahia',
        displayName: 'GMT-03:00 巴伊亚 -03',
        nameLocalized: '巴伊亚',
        abbreviationStandard: '-03',
        id: 74
    },
    {
        name: 'America/Belem',
        displayName: 'GMT-03:00 贝伦 -03',
        nameLocalized: '贝伦',
        abbreviationStandard: '-03',
        id: 76
    },
    {
        name: 'America/Buenos_Aires',
        displayName: 'GMT-03:00 布宜诺斯艾利斯 -03/-02',
        nameLocalized: '布宜诺斯艾利斯',
        abbreviationStandard: '-03/-02',
        id: 82,
        enabled: true
    },
    {
        name: 'America/Fortaleza',
        displayName: 'GMT-03:00 福塔雷萨 -03',
        nameLocalized: '福塔雷萨',
        abbreviationStandard: '-03',
        id: 108
    },
    {
        name: 'America/Jujuy',
        displayName: 'GMT-03:00 胡胡伊 -03',
        nameLocalized: '胡胡伊',
        abbreviationStandard: '-03',
        id: 132
    },
    {
        name: 'America/Catamarca',
        displayName: 'GMT-03:00 卡塔马卡 -03',
        nameLocalized: '卡塔马卡',
        abbreviationStandard: '-03',
        id: 87
    },
    {
        name: 'America/Cayenne',
        displayName: 'GMT-03:00 卡宴 -03',
        nameLocalized: '卡宴',
        abbreviationStandard: '-03',
        id: 88
    },
    {
        name: 'America/Cordoba',
        displayName: 'GMT-03:00 科尔多瓦 -03/-02',
        nameLocalized: '科尔多瓦',
        abbreviationStandard: '-03/-02',
        id: 93
    },
    {
        name: 'America/Argentina/La_Rioja',
        displayName: 'GMT-03:00 拉里奥哈 -03',
        nameLocalized: '拉里奥哈',
        abbreviationStandard: '-03',
        id: 64
    },
    {
        name: 'America/Recife',
        displayName: 'GMT-03:00 累西腓 -03',
        nameLocalized: '累西腓',
        abbreviationStandard: '-03',
        id: 174
    },
    {
        name: 'America/Argentina/Rio_Gallegos',
        displayName: 'GMT-03:00 里奥加耶戈斯 -03',
        nameLocalized: '里奥加耶戈斯',
        abbreviationStandard: '-03',
        id: 66
    },
    {
        name: 'Antarctica/Rothera',
        displayName: 'GMT-03:00 罗瑟拉 -03',
        nameLocalized: '罗瑟拉',
        abbreviationStandard: '-03',
        id: 208
    },
    {
        name: 'America/Maceio',
        displayName: 'GMT-03:00 马塞约 -03',
        nameLocalized: '马塞约',
        abbreviationStandard: '-03',
        id: 141
    },
    {
        name: 'America/Mendoza',
        displayName: 'GMT-03:00 门多萨 -03',
        nameLocalized: '门多萨',
        abbreviationStandard: '-03',
        id: 146
    },
    {
        name: 'America/Montevideo',
        displayName: 'GMT-03:00 蒙得维的亚 -03/-02',
        nameLocalized: '蒙得维的亚',
        abbreviationStandard: '-03/-02',
        id: 153,
        enabled: true
    },
    {
        name: 'America/Miquelon',
        displayName: 'GMT-03:00 密克隆 -03/-02',
        nameLocalized: '密克隆',
        abbreviationStandard: '-03/-02',
        abbreviationDaylight: '-03/-02',
        id: 150
    },
    {
        name: 'America/Godthab',
        displayName: 'GMT-03:00 努克 -03/-02',
        nameLocalized: '努克',
        abbreviationStandard: '-03/-02',
        abbreviationDaylight: '-03/-02',
        id: 110,
        enabled: true
    },
    {
        name: 'America/Paramaribo',
        displayName: 'GMT-03:00 帕拉马里博 -03',
        nameLocalized: '帕拉马里博',
        abbreviationStandard: '-03',
        id: 165
    },
    {
        name: 'Antarctica/Palmer',
        displayName: 'GMT-03:00 帕默尔 -03',
        nameLocalized: '帕默尔',
        abbreviationStandard: '-03',
        id: 207
    },
    {
        name: 'America/Sao_Paulo',
        displayName: 'GMT-03:00 圣保罗 -03/-02',
        nameLocalized: '圣保罗',
        abbreviationStandard: '-03/-02',
        id: 181,
        enabled: true
    },
    {
        name: 'America/Argentina/San_Juan',
        displayName: 'GMT-03:00 圣胡安 -03',
        nameLocalized: '圣胡安',
        abbreviationStandard: '-03',
        id: 67
    },
    {
        name: 'Atlantic/Stanley',
        displayName: 'GMT-03:00 斯坦利 -03',
        nameLocalized: '斯坦利',
        abbreviationStandard: '-03',
        id: 308
    },
    {
        name: 'America/Argentina/Tucuman',
        displayName: 'GMT-03:00 图库曼 -03/-02',
        nameLocalized: '图库曼',
        abbreviationStandard: '-03/-02',
        id: 68
    },
    {
        name: 'America/Argentina/Ushuaia',
        displayName: 'GMT-03:00 乌斯怀亚 -03',
        nameLocalized: '乌斯怀亚',
        abbreviationStandard: '-03',
        id: 69
    },
    {
        name: 'America/Aruba',
        displayName: 'GMT-04:00 阿鲁巴 AST',
        nameLocalized: '阿鲁巴',
        abbreviationStandard: 'AST',
        id: 70
    },
    {
        name: 'America/Anguilla',
        displayName: 'GMT-04:00 安圭拉 AST',
        nameLocalized: '安圭拉',
        abbreviationStandard: 'AST',
        id: 56
    },
    {
        name: 'America/Antigua',
        displayName: 'GMT-04:00 安提瓜 AST',
        nameLocalized: '安提瓜',
        abbreviationStandard: 'AST',
        id: 57
    },
    {
        name: 'America/Barbados',
        displayName: 'GMT-04:00 巴巴多斯 AST',
        nameLocalized: '巴巴多斯',
        abbreviationStandard: 'AST',
        id: 75
    },
    {
        name: 'Atlantic/Bermuda',
        displayName: 'GMT-04:00 百慕大 AST',
        nameLocalized: '百慕大',
        abbreviationStandard: 'AST',
        abbreviationDaylight: 'ADT',
        id: 298
    },
    {
        name: 'America/Puerto_Rico',
        displayName: 'GMT-04:00 波多黎各 AST',
        nameLocalized: '波多黎各',
        abbreviationStandard: 'AST',
        id: 171
    },
    {
        name: 'America/Porto_Velho',
        displayName: 'GMT-04:00 波多韦柳 -04',
        nameLocalized: '波多韦柳',
        abbreviationStandard: '-04',
        id: 170
    },
    {
        name: 'America/Boa_Vista',
        displayName: 'GMT-04:00 博阿维斯塔 -04',
        nameLocalized: '博阿维斯塔',
        abbreviationStandard: '-04',
        id: 79
    },
    {
        name: 'America/Blanc-Sablon',
        displayName: 'GMT-04:00 布兰克萨布隆 AST',
        nameLocalized: '布兰克萨布隆',
        abbreviationStandard: 'AST',
        id: 78
    },
    {
        name: 'America/Campo_Grande',
        displayName: 'GMT-04:00 大坎普 -04/-03',
        nameLocalized: '大坎普',
        abbreviationStandard: '-04/-03',
        id: 84
    },
    {
        name: 'America/Dominica',
        displayName: 'GMT-04:00 多米尼加 AST',
        nameLocalized: '多米尼加',
        abbreviationStandard: 'AST',
        id: 102
    },
    {
        name: 'America/Glace_Bay',
        displayName: 'GMT-04:00 格莱斯贝 AST',
        nameLocalized: '格莱斯贝',
        abbreviationStandard: 'AST',
        abbreviationDaylight: 'ADT',
        id: 109
    },
    {
        name: 'America/Grenada',
        displayName: 'GMT-04:00 格林纳达 AST',
        nameLocalized: '格林纳达',
        abbreviationStandard: 'AST',
        id: 113
    },
    {
        name: 'America/Goose_Bay',
        displayName: 'GMT-04:00 古斯湾 AST',
        nameLocalized: '古斯湾',
        abbreviationStandard: 'AST',
        abbreviationDaylight: 'ADT',
        id: 111,
        enabled: true
    },
    {
        name: 'America/Guadeloupe',
        displayName: 'GMT-04:00 瓜德罗普 AST',
        nameLocalized: '瓜德罗普',
        abbreviationStandard: 'AST',
        id: 114
    },
    {
        name: 'America/Guyana',
        displayName: 'GMT-04:00 圭亚那 -04',
        nameLocalized: '圭亚那',
        abbreviationStandard: '-04',
        id: 117
    },
    {
        name: 'America/Halifax',
        displayName: 'GMT-04:00 哈利法克斯 AST',
        nameLocalized: '哈利法克斯',
        abbreviationStandard: 'AST',
        abbreviationDaylight: 'ADT',
        id: 118
    },
    {
        name: 'America/Caracas',
        displayName: 'GMT-04:00 加拉加斯 -04',
        nameLocalized: '加拉加斯',
        abbreviationStandard: '-04',
        id: 86,
        enabled: true
    },
    {
        name: 'America/Curacao',
        displayName: 'GMT-04:00 库拉索 AST',
        nameLocalized: '库拉索',
        abbreviationStandard: 'AST',
        id: 96
    },
    {
        name: 'America/Cuiaba',
        displayName: 'GMT-04:00 库亚巴 -04/-03',
        nameLocalized: '库亚巴',
        abbreviationStandard: '-04/-03',
        id: 95
    },
    {
        name: 'America/La_Paz',
        displayName: 'GMT-04:00 拉巴斯 -04',
        nameLocalized: '拉巴斯',
        abbreviationStandard: '-04',
        id: 137,
        enabled: true
    },
    {
        name: 'America/Manaus',
        displayName: 'GMT-04:00 马瑙斯 -04',
        nameLocalized: '马瑙斯',
        abbreviationStandard: '-04',
        id: 143,
        enabled: true
    },
    {
        name: 'America/Martinique',
        displayName: 'GMT-04:00 马提尼克 AST',
        nameLocalized: '马提尼克',
        abbreviationStandard: 'AST',
        id: 144
    },
    {
        name: 'America/Moncton',
        displayName: 'GMT-04:00 蒙克顿 AST',
        nameLocalized: '蒙克顿',
        abbreviationStandard: 'AST',
        abbreviationDaylight: 'ADT',
        id: 151
    },
    {
        name: 'America/Montserrat',
        displayName: 'GMT-04:00 蒙特塞拉特 AST',
        nameLocalized: '蒙特塞拉特',
        abbreviationStandard: 'AST',
        id: 155
    },
    {
        name: 'America/Santiago',
        displayName: 'GMT-04:00 圣地亚哥 -04/-03',
        nameLocalized: '圣地亚哥',
        abbreviationStandard: '-04/-03',
        abbreviationDaylight: '-04/-03',
        id: 179,
        enabled: true
    },
    {
        name: 'America/Santo_Domingo',
        displayName: 'GMT-04:00 圣多明各 AST',
        nameLocalized: '圣多明各',
        abbreviationStandard: 'AST',
        id: 180
    },
    {
        name: 'America/St_Kitts',
        displayName: 'GMT-04:00 圣基茨 AST',
        nameLocalized: '圣基茨',
        abbreviationStandard: 'AST',
        id: 185
    },
    {
        name: 'America/St_Lucia',
        displayName: 'GMT-04:00 圣卢西亚 AST',
        nameLocalized: '圣卢西亚',
        abbreviationStandard: 'AST',
        id: 186
    },
    {
        name: 'America/St_Thomas',
        displayName: 'GMT-04:00 圣托马斯 AST',
        nameLocalized: '圣托马斯',
        abbreviationStandard: 'AST',
        id: 187
    },
    {
        name: 'America/St_Vincent',
        displayName: 'GMT-04:00 圣文森特 AST',
        nameLocalized: '圣文森特',
        abbreviationStandard: 'AST',
        id: 188
    },
    {
        name: 'America/Thule',
        displayName: 'GMT-04:00 图勒 AST',
        nameLocalized: '图勒',
        abbreviationStandard: 'AST',
        abbreviationDaylight: 'ADT',
        id: 191
    },
    {
        name: 'America/Tortola',
        displayName: 'GMT-04:00 托尔托拉 AST',
        nameLocalized: '托尔托拉',
        abbreviationStandard: 'AST',
        id: 195
    },
    {
        name: 'America/Port_of_Spain',
        displayName: 'GMT-04:00 西班牙港 AST',
        nameLocalized: '西班牙港',
        abbreviationStandard: 'AST',
        id: 168
    },
    {
        name: 'America/Asuncion',
        displayName: 'GMT-04:00 亚松森 -04/-03',
        nameLocalized: '亚松森',
        abbreviationStandard: '-04/-03',
        abbreviationDaylight: '-04/-03',
        id: 71
    },
    {
        name: 'America/Coral_Harbour',
        displayName: 'GMT-05:00 阿蒂科肯 EST',
        nameLocalized: '阿蒂科肯',
        abbreviationStandard: 'EST',
        id: 92
    },
    {
        name: 'America/Panama',
        displayName: 'GMT-05:00 巴拿马 EST',
        nameLocalized: '巴拿马',
        abbreviationStandard: 'EST',
        id: 163
    },
    {
        name: 'America/Bogota',
        displayName: 'GMT-05:00 波哥大 -05/-04',
        nameLocalized: '波哥大',
        abbreviationStandard: '-05/-04',
        id: 80,
        enabled: true
    },
    {
        name: 'America/Grand_Turk',
        displayName: 'GMT-05:00 大特克 EST',
        nameLocalized: '大特克',
        abbreviationStandard: 'EST',
        abbreviationDaylight: 'EDT',
        id: 112
    },
    {
        name: 'America/Detroit',
        displayName: 'GMT-05:00 底特律 EST',
        nameLocalized: '底特律',
        abbreviationStandard: 'EST',
        abbreviationDaylight: 'EDT',
        id: 101
    },
    {
        name: 'America/Toronto',
        displayName: 'GMT-05:00 多伦多 EST',
        nameLocalized: '多伦多',
        abbreviationStandard: 'EST',
        abbreviationDaylight: 'EDT',
        id: 194
    },
    {
        name: 'America/Guayaquil',
        displayName: 'GMT-05:00 瓜亚基尔 -05/-04',
        nameLocalized: '瓜亚基尔',
        abbreviationStandard: '-05/-04',
        id: 116
    },
    {
        name: 'America/Havana',
        displayName: 'GMT-05:00 哈瓦那 CST',
        nameLocalized: '哈瓦那',
        abbreviationStandard: 'CST',
        abbreviationDaylight: 'CDT',
        id: 119
    },
    {
        name: 'America/Cayman',
        displayName: 'GMT-05:00 开曼 EST',
        nameLocalized: '开曼',
        abbreviationStandard: 'EST',
        id: 89
    },
    {
        name: 'America/Cancun',
        displayName: 'GMT-05:00 坎昆 EST',
        nameLocalized: '坎昆',
        abbreviationStandard: 'EST',
        id: 85
    },
    {
        name: 'America/Kentucky/Monticello',
        displayName: 'GMT-05:00 肯塔基州蒙蒂塞洛 EST',
        nameLocalized: '肯塔基州蒙蒂塞洛',
        abbreviationStandard: 'EST',
        abbreviationDaylight: 'EDT',
        id: 135
    },
    {
        name: 'America/Rio_Branco',
        displayName: 'GMT-05:00 里奥布郎库 -05',
        nameLocalized: '里奥布郎库',
        abbreviationStandard: '-05',
        id: 177
    },
    {
        name: 'America/Lima',
        displayName: 'GMT-05:00 利马 -05/-04',
        nameLocalized: '利马',
        abbreviationStandard: '-05/-04',
        id: 138
    },
    {
        name: 'America/Louisville',
        displayName: 'GMT-05:00 路易斯维尔 EST',
        nameLocalized: '路易斯维尔',
        abbreviationStandard: 'EST',
        abbreviationDaylight: 'EDT',
        id: 140
    },
    {
        name: 'America/Nassau',
        displayName: 'GMT-05:00 拿骚 EST',
        nameLocalized: '拿骚',
        abbreviationStandard: 'EST',
        abbreviationDaylight: 'EDT',
        id: 156
    },
    {
        name: 'America/Nipigon',
        displayName: 'GMT-05:00 尼皮贡 EST',
        nameLocalized: '尼皮贡',
        abbreviationStandard: 'EST',
        abbreviationDaylight: 'EDT',
        id: 158
    },
    {
        name: 'America/New_York',
        displayName: 'GMT-05:00 纽约 EST',
        nameLocalized: '纽约',
        abbreviationStandard: 'EST',
        abbreviationDaylight: 'EDT',
        id: 157,
        enabled: true
    },
    {
        name: 'America/Pangnirtung',
        displayName: 'GMT-05:00 旁涅唐 EST',
        nameLocalized: '旁涅唐',
        abbreviationStandard: 'EST',
        abbreviationDaylight: 'EDT',
        id: 164
    },
    {
        name: 'America/Thunder_Bay',
        displayName: 'GMT-05:00 桑德贝 EST',
        nameLocalized: '桑德贝',
        abbreviationStandard: 'EST',
        abbreviationDaylight: 'EDT',
        id: 192
    },
    {
        name: 'America/Port-au-Prince',
        displayName: 'GMT-05:00 太子港 EST',
        nameLocalized: '太子港',
        abbreviationStandard: 'EST',
        abbreviationDaylight: 'EDT',
        id: 167
    },
    {
        name: 'America/Jamaica',
        displayName: 'GMT-05:00 牙买加 EST',
        nameLocalized: '牙买加',
        abbreviationStandard: 'EST',
        id: 131
    },
    {
        name: 'America/Iqaluit',
        displayName: 'GMT-05:00 伊魁特 EST',
        nameLocalized: '伊魁特',
        abbreviationStandard: 'EST',
        abbreviationDaylight: 'EDT',
        id: 130
    },
    {
        name: 'America/Eirunepe',
        displayName: 'GMT-05:00 依伦尼贝 -05',
        nameLocalized: '依伦尼贝',
        abbreviationStandard: '-05',
        id: 104
    },
    {
        name: 'America/Indianapolis',
        displayName: 'GMT-05:00 印第安纳波利斯 EST',
        nameLocalized: '印第安纳波利斯',
        abbreviationStandard: 'EST',
        abbreviationDaylight: 'EDT',
        id: 128
    },
    {
        name: 'America/Indiana/Petersburg',
        displayName: 'GMT-05:00 印第安纳州彼得斯堡 EST',
        nameLocalized: '印第安纳州彼得斯堡',
        abbreviationStandard: 'EST',
        abbreviationDaylight: 'EDT',
        id: 124
    },
    {
        name: 'America/Indiana/Marengo',
        displayName: 'GMT-05:00 印第安纳州马伦戈 EST',
        nameLocalized: '印第安纳州马伦戈',
        abbreviationStandard: 'EST',
        abbreviationDaylight: 'EDT',
        id: 123
    },
    {
        name: 'America/Indiana/Winamac',
        displayName: 'GMT-05:00 印第安纳州威纳马克 EST',
        nameLocalized: '印第安纳州威纳马克',
        abbreviationStandard: 'EST',
        abbreviationDaylight: 'EDT',
        id: 127
    },
    {
        name: 'America/Indiana/Vevay',
        displayName: 'GMT-05:00 印第安纳州维维市 EST',
        nameLocalized: '印第安纳州维维市',
        abbreviationStandard: 'EST',
        abbreviationDaylight: 'EDT',
        id: 125
    },
    {
        name: 'America/Indiana/Vincennes',
        displayName: 'GMT-05:00 印第安纳州温森斯 EST',
        nameLocalized: '印第安纳州温森斯',
        abbreviationStandard: 'EST',
        abbreviationDaylight: 'EDT',
        id: 126
    },
    {
        name: 'America/North_Dakota/Center',
        displayName: 'GMT-06:00 北达科他州申特 CST',
        nameLocalized: '北达科他州申特',
        abbreviationStandard: 'CST',
        abbreviationDaylight: 'CDT',
        id: 161
    },
    {
        name: 'America/North_Dakota/New_Salem',
        displayName: 'GMT-06:00 北达科他州新塞勒姆 CST',
        nameLocalized: '北达科他州新塞勒姆',
        abbreviationStandard: 'CST',
        abbreviationDaylight: 'CDT',
        id: 162
    },
    {
        name: 'America/Belize',
        displayName: 'GMT-06:00 伯利兹 CST',
        nameLocalized: '伯利兹',
        abbreviationStandard: 'CST',
        id: 77
    },
    {
        name: 'Pacific/Easter',
        displayName: 'GMT-06:00 复活节岛 -06/-05',
        nameLocalized: '复活节岛',
        abbreviationStandard: '-06/-05',
        abbreviationDaylight: '-06/-05',
        id: 488
    },
    {
        name: 'America/Costa_Rica',
        displayName: 'GMT-06:00 哥斯达黎加 CST',
        nameLocalized: '哥斯达黎加',
        abbreviationStandard: 'CST',
        id: 94
    },
    {
        name: 'Pacific/Galapagos',
        displayName: 'GMT-06:00 加拉帕戈斯 -06/-05',
        nameLocalized: '加拉帕戈斯',
        abbreviationStandard: '-06/-05',
        id: 494
    },
    {
        name: 'America/Rankin_Inlet',
        displayName: 'GMT-06:00 兰今湾 CST',
        nameLocalized: '兰今湾',
        abbreviationStandard: 'CST',
        abbreviationDaylight: 'CDT',
        id: 173
    },
    {
        name: 'America/Rainy_River',
        displayName: 'GMT-06:00 雷尼河 CST',
        nameLocalized: '雷尼河',
        abbreviationStandard: 'CST',
        abbreviationDaylight: 'CDT',
        id: 172
    },
    {
        name: 'America/Resolute',
        displayName: 'GMT-06:00 雷索卢特 CST',
        nameLocalized: '雷索卢特',
        abbreviationStandard: 'CST',
        abbreviationDaylight: 'CDT',
        id: 176
    },
    {
        name: 'America/Regina',
        displayName: 'GMT-06:00 里贾纳 CST',
        nameLocalized: '里贾纳',
        abbreviationStandard: 'CST',
        id: 175
    },
    {
        name: 'America/Managua',
        displayName: 'GMT-06:00 马那瓜 CST',
        nameLocalized: '马那瓜',
        abbreviationStandard: 'CST',
        id: 142
    },
    {
        name: 'America/Merida',
        displayName: 'GMT-06:00 梅里达 CST',
        nameLocalized: '梅里达',
        abbreviationStandard: 'CST',
        abbreviationDaylight: 'CDT',
        id: 148
    },
    {
        name: 'America/Menominee',
        displayName: 'GMT-06:00 梅诺米尼 CST',
        nameLocalized: '梅诺米尼',
        abbreviationStandard: 'CST',
        abbreviationDaylight: 'CDT',
        id: 147
    },
    {
        name: 'America/Monterrey',
        displayName: 'GMT-06:00 蒙特雷 CST',
        nameLocalized: '蒙特雷',
        abbreviationStandard: 'CST',
        abbreviationDaylight: 'CDT',
        id: 152
    },
    {
        name: 'America/Mexico_City',
        displayName: 'GMT-06:00 墨西哥城 CST',
        nameLocalized: '墨西哥城',
        abbreviationStandard: 'CST',
        abbreviationDaylight: 'CDT',
        id: 149,
        enabled: true
    },
    {
        name: 'America/El_Salvador',
        displayName: 'GMT-06:00 萨尔瓦多 CST',
        nameLocalized: '萨尔瓦多',
        abbreviationStandard: 'CST',
        id: 105
    },
    {
        name: 'America/Swift_Current',
        displayName: 'GMT-06:00 斯威夫特卡伦特 CST',
        nameLocalized: '斯威夫特卡伦特',
        abbreviationStandard: 'CST',
        id: 189
    },
    {
        name: 'America/Tegucigalpa',
        displayName: 'GMT-06:00 特古西加尔巴 CST',
        nameLocalized: '特古西加尔巴',
        abbreviationStandard: 'CST',
        id: 190
    },
    {
        name: 'America/Guatemala',
        displayName: 'GMT-06:00 危地马拉 CST',
        nameLocalized: '危地马拉',
        abbreviationStandard: 'CST',
        id: 115,
        enabled: true
    },
    {
        name: 'America/Winnipeg',
        displayName: 'GMT-06:00 温尼伯 CST',
        nameLocalized: '温尼伯',
        abbreviationStandard: 'CST',
        abbreviationDaylight: 'CDT',
        id: 199
    },
    {
        name: 'America/Indiana/Knox',
        displayName: 'GMT-06:00 印第安纳州诺克斯 CST',
        nameLocalized: '印第安纳州诺克斯',
        abbreviationStandard: 'CST',
        abbreviationDaylight: 'CDT',
        id: 122
    },
    {
        name: 'America/Chicago',
        displayName: 'GMT-06:00 芝加哥 CST',
        nameLocalized: '芝加哥',
        abbreviationStandard: 'CST',
        abbreviationDaylight: 'CDT',
        id: 90,
        enabled: true
    },
    {
        name: 'America/Edmonton',
        displayName: 'GMT-07:00 埃德蒙顿 MST',
        nameLocalized: '埃德蒙顿',
        abbreviationStandard: 'MST',
        abbreviationDaylight: 'MDT',
        id: 103
    },
    {
        name: 'America/Hermosillo',
        displayName: 'GMT-07:00 埃莫西约 MST',
        nameLocalized: '埃莫西约',
        abbreviationStandard: 'MST',
        id: 120
    },
    {
        name: 'America/Boise',
        displayName: 'GMT-07:00 博伊西 MST',
        nameLocalized: '博伊西',
        abbreviationStandard: 'MST',
        abbreviationDaylight: 'MDT',
        id: 81
    },
    {
        name: 'America/Denver',
        displayName: 'GMT-07:00 丹佛 MST',
        nameLocalized: '丹佛',
        abbreviationStandard: 'MST',
        abbreviationDaylight: 'MDT',
        id: 100,
        enabled: true
    },
    {
        name: 'America/Dawson',
        displayName: 'GMT-07:00 道森 MST',
        nameLocalized: '道森',
        abbreviationStandard: 'MST',
        id: 98
    },
    {
        name: 'America/Dawson_Creek',
        displayName: 'GMT-07:00 道森克里克 MST',
        nameLocalized: '道森克里克',
        abbreviationStandard: 'MST',
        id: 99
    },
    {
        name: 'America/Phoenix',
        displayName: 'GMT-07:00 凤凰城 MST',
        nameLocalized: '凤凰城',
        abbreviationStandard: 'MST',
        id: 166,
        enabled: true
    },
    {
        name: 'America/Whitehorse',
        displayName: 'GMT-07:00 怀特霍斯 MST',
        nameLocalized: '怀特霍斯',
        abbreviationStandard: 'MST',
        id: 198
    },
    {
        name: 'America/Cambridge_Bay',
        displayName: 'GMT-07:00 剑桥湾 MST',
        nameLocalized: '剑桥湾',
        abbreviationStandard: 'MST',
        abbreviationDaylight: 'MDT',
        id: 83
    },
    {
        name: 'America/Mazatlan',
        displayName: 'GMT-07:00 马萨特兰 MST',
        nameLocalized: '马萨特兰',
        abbreviationStandard: 'MST',
        abbreviationDaylight: 'MDT',
        id: 145
    },
    {
        name: 'America/Chihuahua',
        displayName: 'GMT-07:00 奇瓦瓦 MST',
        nameLocalized: '奇瓦瓦',
        abbreviationStandard: 'MST',
        abbreviationDaylight: 'MDT',
        id: 91,
        enabled: true
    },
    {
        name: 'America/Yellowknife',
        displayName: 'GMT-07:00 耶洛奈夫 MST',
        nameLocalized: '耶洛奈夫',
        abbreviationStandard: 'MST',
        abbreviationDaylight: 'MDT',
        id: 201
    },
    {
        name: 'America/Inuvik',
        displayName: 'GMT-07:00 伊努维克 MST',
        nameLocalized: '伊努维克',
        abbreviationStandard: 'MST',
        abbreviationDaylight: 'MDT',
        id: 129
    },
    {
        name: 'America/Tijuana',
        displayName: 'GMT-08:00 蒂华纳 PST',
        nameLocalized: '蒂华纳',
        abbreviationStandard: 'PST',
        abbreviationDaylight: 'PDT',
        id: 193,
        enabled: true
    },
    {
        name: 'America/Los_Angeles',
        displayName: 'GMT-08:00 洛杉矶 PST',
        nameLocalized: '洛杉矶',
        abbreviationStandard: 'PST',
        abbreviationDaylight: 'PDT',
        id: 139,
        enabled: true
    },
    {
        name: 'Pacific/Pitcairn',
        displayName: 'GMT-08:00 皮特凯恩 -08',
        nameLocalized: '皮特凯恩',
        abbreviationStandard: '-08',
        id: 512
    },
    {
        name: 'America/Vancouver',
        displayName: 'GMT-08:00 温哥华 PST',
        nameLocalized: '温哥华',
        abbreviationStandard: 'PST',
        abbreviationDaylight: 'PDT',
        id: 196
    },
    {
        name: 'Pacific/Marquesas',
        displayName: 'GMT-09:30 马克萨斯 -0930',
        nameLocalized: '马克萨斯',
        abbreviationStandard: '-0930',
        id: 504
    },
    {
        name: 'America/Anchorage',
        displayName: 'GMT-09:00 安克雷奇 AKST',
        nameLocalized: '安克雷奇',
        abbreviationStandard: 'AKST',
        abbreviationDaylight: 'AKDT',
        id: 55
    },
    {
        name: 'Pacific/Gambier',
        displayName: 'GMT-09:00 甘比尔 -09',
        nameLocalized: '甘比尔',
        abbreviationStandard: '-09',
        id: 495
    },
    {
        name: 'America/Nome',
        displayName: 'GMT-09:00 诺姆 AKST',
        nameLocalized: '诺姆',
        abbreviationStandard: 'AKST',
        abbreviationDaylight: 'AKDT',
        id: 159
    },
    {
        name: 'America/Yakutat',
        displayName: 'GMT-09:00 亚库塔特 AKST',
        nameLocalized: '亚库塔特',
        abbreviationStandard: 'AKST',
        abbreviationDaylight: 'AKDT',
        id: 200
    },
    {
        name: 'America/Juneau',
        displayName: 'GMT-09:00 朱诺 AKST',
        nameLocalized: '朱诺',
        abbreviationStandard: 'AKST',
        abbreviationDaylight: 'AKDT',
        id: 133,
        enabled: true
    },
    {
        name: 'America/Adak',
        displayName: 'GMT-10:00 埃达克 HST',
        nameLocalized: '埃达克',
        abbreviationStandard: 'HST',
        abbreviationDaylight: 'HDT',
        id: 54
    },
    {
        name: 'Pacific/Rarotonga',
        displayName: 'GMT-10:00 拉罗汤加 -10/-0930',
        nameLocalized: '拉罗汤加',
        abbreviationStandard: '-10/-0930',
        id: 515
    },
    {
        name: 'Pacific/Tahiti',
        displayName: 'GMT-10:00 塔希提 -10',
        nameLocalized: '塔希提',
        abbreviationStandard: '-10',
        id: 518
    },
    {
        name: 'Pacific/Honolulu',
        displayName: 'GMT-10:00 檀香山 HST',
        nameLocalized: '檀香山',
        abbreviationStandard: 'HST',
        id: 498,
        enabled: true
    },
    {
        name: 'Pacific/Johnston',
        displayName: 'GMT-10:00 约翰斯顿 HST',
        nameLocalized: '约翰斯顿',
        abbreviationStandard: 'HST',
        id: 499
    },
    {
        name: 'Pacific/Niue',
        displayName: 'GMT-11:00 纽埃 -11',
        nameLocalized: '纽埃',
        abbreviationStandard: '-11',
        id: 507
    },
    {
        name: 'Pacific/Pago_Pago',
        displayName: 'GMT-11:00 帕果帕果 SST',
        nameLocalized: '帕果帕果',
        abbreviationStandard: 'SST',
        id: 510
    },
    {
        name: 'Pacific/Midway',
        displayName: 'GMT-11:00 中途岛 -11',
        nameLocalized: '中途岛',
        abbreviationStandard: '-11',
        id: 505,
        enabled: true
    },
];
var weekData = {
    firstDay: 0,
    weekendStart: 6,
    weekendEnd: 0
};
var weekDayNames = {
    days: {
        abbreviated: {
            sun: '周日',
            mon: '周一',
            tue: '周二',
            wed: '周三',
            thu: '周四',
            fri: '周五',
            sat: '周六'
        },
        narrow: {
            sun: '日',
            mon: '一',
            tue: '二',
            wed: '三',
            thu: '四',
            fri: '五',
            sat: '六'
        },
        short: {
            sun: '周日',
            mon: '周一',
            tue: '周二',
            wed: '周三',
            thu: '周四',
            fri: '周五',
            sat: '周六'
        },
        wide: {
            sun: '星期日',
            mon: '星期一',
            tue: '星期二',
            wed: '星期三',
            thu: '星期四',
            fri: '星期五',
            sat: '星期六'
        }
    },
    standAlone: {
        abbreviated: {
            sun: '周日',
            mon: '周一',
            tue: '周二',
            wed: '周三',
            thu: '周四',
            fri: '周五',
            sat: '周六'
        },
        narrow: {
            sun: '日',
            mon: '一',
            tue: '二',
            wed: '三',
            thu: '四',
            fri: '五',
            sat: '六'
        },
        short: {
            sun: '周日',
            mon: '周一',
            tue: '周二',
            wed: '周三',
            thu: '周四',
            fri: '周五',
            sat: '周六'
        },
        wide: {
            sun: '星期日',
            mon: '星期一',
            tue: '星期二',
            wed: '星期三',
            thu: '星期四',
            fri: '星期五',
            sat: '星期六'
        }
    }
};
var data = {
    languages: languages,
    numbers: numbers,
    timezones: timezones,
    weekData: weekData,
    weekDayNames: weekDayNames
};
exports["default"] = data;
